import React from 'react';
import {
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { resolveStatusToken } from '../../../../constants/statusTokens';

const columns = [
  { id: 'timestamp', label: 'Timestamp' },
  { id: 'camera', label: 'Camera' },
  { id: 'client', label: 'Client' },
  { id: 'confidence', label: 'Confidence' },
  { id: 'status', label: 'Status' },
  { id: 'actions', label: '', align: 'right' },
];

const FallEventsTable = ({ events, onSelect }) => {
  if (!events.length) {
    return <Typography color="text.secondary">No events match the current filters.</Typography>;
  }

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id} align={column.align || 'left'}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {events.map((event) => {
            const statusToken = resolveStatusToken(event.status, 'fallEvents');
            return (
              <TableRow
                key={event.id}
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => onSelect?.(event)}
              >
                <TableCell sx={{ width: 200 }}>{new Date(event.timestamp).toLocaleString()}</TableCell>
                <TableCell>{event.camera?.name || 'Unknown camera'}</TableCell>
                <TableCell>{event.client_name || 'Unassigned'}</TableCell>
                <TableCell>
                  {typeof event.confidence === 'number'
                    ? `${(event.confidence * 100).toFixed(1)}%`
                    : 'N/A'}
                </TableCell>
                <TableCell>
                  <Chip
                    label={statusToken?.label || event.status?.toLowerCase() || 'Unknown'}
                    color={statusToken?.color === 'default' ? 'primary' : statusToken?.color}
                    size="small"
                    sx={{ textTransform: 'capitalize' }}
                  />
                </TableCell>
                <TableCell align="right">
                  <Button
                    size="small"
                    endIcon={<ArrowForwardIcon fontSize="small" />}
                    onClick={(eventClick) => {
                      eventClick.stopPropagation();
                      onSelect?.(event);
                    }}
                  >
                    View details
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FallEventsTable;
